import cubePink from "assets/images/cube-pink.png";
import cubeYellow from "assets/images/cube-yellow.png";
import cubeBlue from "assets/images/cube-blue.png";
import css from "./styles.module.scss";
import cn from "classnames";

import { useMemo } from "react";
import { useParentsHeight } from "shared/hooks/useParentsHeight";

const CUBE_SPACING = 400;
const OFFSET = 20;

export const BackgroundCubes = ({ className, parentElement }) => {
  const screenHeight = useParentsHeight(parentElement);

  const cubes = useMemo(() => {
    const CUBES_COUNT = Math.floor(screenHeight / CUBE_SPACING);
    return Array.from({ length: CUBES_COUNT }, (_, i) => ({
      img: i % 3 === 0 ? cubeYellow : i % 3 === 1 ? cubePink : cubeBlue,
      top: i * CUBE_SPACING + OFFSET,
    }));
  }, [screenHeight]);

  return (
    <div className={css.BackgroundCubes}>
      {cubes.map((cube, i) => (
        <img
          key={i}
          src={cube.img}
          className={cn(
            css.cube,
            { [css.right]: i % 2, [css.left]: !(i % 2) },
            className
          )}
          style={{ top: `${cube.top}px` }}
        />
      ))}
    </div>
  );
};
